import React from "react";

import Text from "src/components/text";

import { formatTimespent } from "src/services/reports.service";

import styles from "./topViewerCard.module.scss";
import { Contact } from "src/types/contact";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

interface TopViewerItem {
  contact: Contact;
  analytics: Analytics;
}

interface TopViewerCardProps {
  item: TopViewerItem;
  onClick?: () => void;
}

const TopViewerCard: React.FC<TopViewerCardProps> = ({
  item,
  onClick,
}) => {
  const { contact, analytics } = item;
  return (
    <div
      className={styles.card}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <img
        src={contact.icon?.thumbnail || DefaultAssetIcon}
        className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
        alt={`${contact.firstName} ${contact.lastName}`}
      />
      <div className={styles.content}>
        <Text
          text={`${contact.firstName}${contact.lastName ? ` ${contact.lastName}` : ""}`}
          className={styles.title}
          lines={1}
        />
        <div className={styles.metrics}>
          <span>{analytics.views || 0} Views</span>
          <span>{formatTimespent(analytics.avgTimeSpent || 0)} Avg Time</span>
          <span>{analytics.shares || 0} Reshares</span>
        </div>
      </div>
    </div>
  );
};

export default TopViewerCard;
